var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStressfree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.38 4H15.62C8.34 4 4 8.34 4 15.62V32.36C4 39.66 8.34 44 15.62 44H32.36C39.64 44 43.98 39.66 43.98 32.38V15.62C44 8.34 39.66 4 32.38 4Z",
    fill: "#E5A40D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.64 19.5C15.94 19.5 14.24 18.86 12.94 17.56C12.36 16.98 12.36 16.02 12.94 15.44C13.52 14.86 14.48 14.86 15.06 15.44C16.48 16.86 18.8 16.86 20.22 15.44C20.8 14.86 21.76 14.86 22.34 15.44C22.92 16.02 22.92 16.98 22.34 17.56C21.04 18.84 19.34 19.5 17.64 19.5Z",
    fill: "#E5A40D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.36 19.5C28.66 19.5 26.96 18.86 25.66 17.56C25.08 16.98 25.08 16.02 25.66 15.44C26.24 14.86 27.2 14.86 27.78 15.44C29.2 16.86 31.52 16.86 32.94 15.44C33.52 14.86 34.48 14.86 35.06 15.44C35.64 16.02 35.64 16.98 35.06 17.56C33.76 18.84 32.06 19.5 30.36 19.5Z",
    fill: "#E5A40D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 25.24H16.8C15.4 25.24 14.26 26.38 14.26 27.8C14.26 33.18 18.64 37.56 24.02 37.56C29.4 37.56 33.78 33.18 33.78 27.8C33.76 26.4 32.6 25.24 31.2 25.24Z",
    fill: "#E5A40D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressfree);
export default __webpack_public_path__ + "static/media/stressfree.dad85716c9cbe8837735fd772bc15996.svg";
export { ForwardRef as ReactComponent };